var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailConfirm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#EmailConfirm_svg__clip0_1054_1708)",
    stroke: "#393939",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5 26.25l12 8.25V66a4.5 4.5 0 01-4.5 4.5H6A4.5 4.5 0 011.5 66V34.5l12-8.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 61.5l15-12h21l15 12M70.5 34.5l-18 12M1.5 34.5l18 12M58.5 42.501V4.5a3 3 0 00-3-3h-39a3 3 0 00-3 3v38.001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 21.812a11.161 11.161 0 01-11 11.19 10.837 10.837 0 01-11-10.809 11.162 11.162 0 0111-11.192 10.84 10.84 0 0111 10.811zM34 25h4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.501 25v-6.5a.5.5 0 00-.812-.39l-1.688 1.35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "EmailConfirm_svg__clip0_1054_1708"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h72v72H0z"
  })))));
}
export default SvgEmailConfirm;